import { ReceiveLetter } from '../../components/receivePage/ReceiveLetter';

export const ReceiveLetterPage = () => {
  return (
    <div>
      <ReceiveLetter />
    </div>
  );
};
